/* ============================================================
   THE LIVING PATH — global JavaScript
   Loaded on every page via theme.liquid
   
   Handles:
   - Custom cursor (dot, ring, trail)
   - Akaal (dark mode) toggle with localStorage persistence
   - Cursor "grow" behavior on interactive elements
   - Nav scroll state
   - Om easter egg
   - Per-page activation (detected via document.body.dataset.page)
   ============================================================ */

(function() {
  'use strict';

  // ============ TOUCH DETECTION ============
  const isTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
  if (isTouch) document.body.classList.add('touch');

  // ============ AKAAL TOGGLE WITH LOCALSTORAGE ============
  // Pre-paint check (runs immediately, before DOMContentLoaded)
  try {
    if (localStorage.getItem('livingpath-akaal') === '1') {
      document.body.classList.add('akaal');
    }
  } catch (e) {}

  function applyAkaal(on) {
    if (on) {
      document.body.classList.add('akaal');
      try { localStorage.setItem('livingpath-akaal', '1'); } catch (e) {}
    } else {
      document.body.classList.remove('akaal');
      try { localStorage.setItem('livingpath-akaal', '0'); } catch (e) {}
    }
  }

  // ============ CUSTOM CURSOR ============
  let cursorDot, cursorRing;
  let mouseX = 0, mouseY = 0, ringX = 0, ringY = 0;

  function initCursor() {
    cursorDot = document.getElementById('cursorDot');
    cursorRing = document.getElementById('cursorRing');
    if (!cursorDot || !cursorRing) return;

    document.addEventListener('mousemove', function(e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      cursorDot.style.left = mouseX + 'px';
      cursorDot.style.top = mouseY + 'px';
      if (Math.random() < 0.18) {
        const t = document.createElement('div');
        t.className = 'trail-dot';
        t.style.left = mouseX + 'px';
        t.style.top = mouseY + 'px';
        document.body.appendChild(t);
        setTimeout(function() { t.remove(); }, 1400);
      }
    });

    (function animateRing() {
      ringX += (mouseX - ringX) * 0.18;
      ringY += (mouseY - ringY) * 0.18;
      if (cursorRing) {
        cursorRing.style.left = ringX + 'px';
        cursorRing.style.top = ringY + 'px';
      }
      requestAnimationFrame(animateRing);
    })();
  }

  function bindCursorGrow() {
    if (!cursorRing) return;
    const interactive = 'a, button, input, .door, .serp-node, .sun-eye, .offering, .mirror .questions li, .home-akaal, .threshold, .aka-tile, .dancefloor, [data-grow]';
    document.querySelectorAll(interactive).forEach(function(el) {
      if (el.dataset.cursorBound) return;
      el.dataset.cursorBound = '1';
      el.addEventListener('mouseenter', function() {
        cursorRing.style.width = '58px';
        cursorRing.style.height = '58px';
        cursorRing.style.borderColor = document.body.classList.contains('akaal') ? 'rgba(217,119,70,0.8)' : 'rgba(179,90,42,0.7)';
      });
      el.addEventListener('mouseleave', function() {
        cursorRing.style.width = '38px';
        cursorRing.style.height = '38px';
        cursorRing.style.borderColor = document.body.classList.contains('akaal') ? 'rgba(236,228,210,0.36)' : 'rgba(74,58,38,0.4)';
      });
    });
  }

  // ============ NAV SCROLL STATE ============
  function initNavScroll() {
    const nav = document.querySelector('nav.site-nav');
    if (!nav) return;
    window.addEventListener('scroll', function() {
      nav.classList.toggle('scrolled', window.scrollY > 30);
    });
  }

  // ============ REVEAL ANIMATION ============
  // Each page's .reveal elements fade in on load
  function revealOnLoad() {
    const reveals = document.querySelectorAll('.reveal');
    reveals.forEach(function(el, i) {
      setTimeout(function() { el.classList.add('visible'); }, i * 60);
    });
  }

  // ============ TRANSMISSION TOAST ============
  // Small bottom-of-screen message for easter eggs / interactions
  function transmit(msg) {
    const transmissionEl = document.getElementById('transmission');
    const transmissionText = document.getElementById('transmissionText');
    if (!transmissionEl || !transmissionText) return;
    transmissionText.textContent = msg;
    transmissionEl.classList.add('show');
    setTimeout(function() { transmissionEl.classList.remove('show'); }, 6000);
  }
  window.transmit = transmit;

  // ============ OM EASTER EGG ============
  let omBuffer = '';
  window.addEventListener('keydown', function(e) {
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
    omBuffer = (omBuffer + (e.key || '').toLowerCase()).slice(-3);
    if (omBuffer.endsWith('om')) {
      document.body.classList.add('illumined');
      transmit('You have arrived.');
      setTimeout(function() { document.body.classList.remove('illumined'); }, 4000);
      omBuffer = '';
    }
  });

  // ============ PER-PAGE ACTIVATION ============
  // Each page sets <body data-page="X"> via the theme.liquid template
  // and this routes to the appropriate page-specific behavior.

  function activateSun() {
    const sunRevelations = [
      'The same that is reading this.',
      'There is no other looker.',
      'You are what you are searching for.',
      'Nothing was ever hidden.',
      'The looking and the looked-at — one thing.'
    ];
    const sunEye = document.getElementById('sunEye');
    const sunEyePrompt = document.getElementById('sunEyePrompt');
    const sunEyeAnswer = document.getElementById('sunEyeAnswer');
    if (!sunEye) return;
    let sunHoldTimer = null;
    sunEye.addEventListener('mouseenter', function() {
      sunHoldTimer = setTimeout(function() {
        sunEye.classList.add('activated');
        if (sunEyePrompt) sunEyePrompt.classList.add('hidden');
        if (sunEyeAnswer) {
          sunEyeAnswer.textContent = sunRevelations[Math.floor(Math.random() * sunRevelations.length)];
          sunEyeAnswer.classList.add('show');
        }
        setTimeout(function() {
          sunEye.classList.remove('activated');
          if (sunEyeAnswer) sunEyeAnswer.classList.remove('show');
          if (sunEyePrompt) sunEyePrompt.classList.remove('hidden');
        }, 5500);
      }, 1800);
    });
    sunEye.addEventListener('mouseleave', function() {
      if (sunHoldTimer) clearTimeout(sunHoldTimer);
    });

    setTimeout(function() {
      document.body.classList.add('sun-brightened');
    }, 22000);
  }

  function activateDance() {
    const df = document.getElementById('dancefloor');
    if (!df) return;
    const orbit3 = df.querySelector('#orbit3');
    df.addEventListener('click', function(e) {
      const rect = df.getBoundingClientRect();
      const cx = (e.clientX - rect.left) / rect.width * 320;
      const cy = (e.clientY - rect.top) / rect.height * 320;
      const dx = cx - 160, dy = cy - 160;
      const angle = Math.atan2(dy, dx);
      const px = 160 + Math.cos(angle) * 140;
      const py = 160 + Math.sin(angle) * 140;
      const c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      c.setAttribute('cx', px);
      c.setAttribute('cy', py);
      c.setAttribute('r', 4);
      c.setAttribute('class', 'dance-dot');
      c.setAttribute('opacity', '0.7');
      if (orbit3) orbit3.appendChild(c);
      transmit('A dancer joined the circle.');
    });
  }

  function activateMountain() {
    function spawnSnow() {
      if (document.body.dataset.page !== 'mountain') return;
      const s = document.createElement('div');
      s.className = 'snow';
      s.style.left = (Math.random() * 100) + 'vw';
      document.body.appendChild(s);
      const duration = 8 + Math.random() * 6;
      s.animate(
        [
          { transform: 'translateY(0)', opacity: 0 },
          { opacity: 0.25, offset: 0.1 },
          { opacity: 0.25, offset: 0.9 },
          { transform: 'translateY(' + (window.innerHeight + 40) + 'px)', opacity: 0 }
        ],
        { duration: duration * 1000, easing: 'linear' }
      );
      setTimeout(function() { s.remove(); }, duration * 1000);
    }
    setInterval(spawnSnow, 1200);
  }

  function activateWave() {
    // Click anywhere on the wave page (except links/buttons) to make a ripple
    document.addEventListener('click', function(e) {
      if (document.body.dataset.page !== 'wave') return;
      if (e.target.closest('a, button, input')) return;
      const r = document.createElement('div');
      r.className = 'ripple';
      r.style.left = e.clientX + 'px';
      r.style.top = e.clientY + 'px';
      document.body.appendChild(r);
      setTimeout(function() { r.remove(); }, 1500);
    });
  }

  function activateAkaalPage() {
    // The akaal page forces akaal mode
    document.body.classList.add('akaal');
  }

  function activateDeep() {
    // The deep page has a master journey path with a drifting marker
    const masterPath = document.getElementById('masterPath');
    const liveMarker = document.getElementById('liveMarker');
    const markerPulse = document.getElementById('markerPulse');
    if (!masterPath || !liveMarker) return;

    function placeOnMaster(t) {
      const total = masterPath.getTotalLength();
      const pt = masterPath.getPointAtLength(total * Math.max(0, Math.min(1, t)));
      liveMarker.setAttribute('cx', pt.x);
      liveMarker.setAttribute('cy', pt.y);
      if (markerPulse) {
        markerPulse.setAttribute('cx', pt.x);
        markerPulse.setAttribute('cy', pt.y);
      }
    }

    let driftT = Math.random() * 0.9;
    let driftDir = 1;
    placeOnMaster(driftT);

    function drift() {
      if (document.body.dataset.page !== 'deep') return;
      driftT += 0.0005 * driftDir;
      if (driftT > 0.98) driftDir = -1;
      if (driftT < 0.02) driftDir = 1;
      placeOnMaster(driftT);
      requestAnimationFrame(drift);
    }
    drift();
  }

  // ============ INIT ============
  function init() {
    initCursor();
    bindCursorGrow();
    initNavScroll();
    revealOnLoad();

    // Akaal toggle button (lives in the layout)
    const toggleBtn = document.getElementById('akaalToggle');
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function() {
        applyAkaal(!document.body.classList.contains('akaal'));
      });
    }

    // Run page-specific activation
    const page = document.body.dataset.page;
    switch (page) {
      case 'sun': activateSun(); break;
      case 'dance': activateDance(); break;
      case 'mountain': activateMountain(); break;
      case 'wave': activateWave(); break;
      case 'akaal': activateAkaalPage(); break;
      case 'deep': activateDeep(); break;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
